/* eslint-disable */
// node_info data 형태(period-sin/period-rec/period-tri/static-모든 방정식 None/static)
// const one_fg_ex_res_code = {
//     'paths': [
//         ['RE-06', 'WL-09', 'WL-04', 'WL-10', 'PW-11', 'WL-06', 'WL-02', 'WL-03', 'WL-08'], 
//         ['WL-09', 'WL-04', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'WL-03', 'RE-05'], 
//         ['RE-02', 'WL-09', 'WL-04', 'WL-05', 'PW-11', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'RE-02', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'WL-02', 'WL-03', 'RE-05']
//         ], 
//     'result': {
//         'RE-03': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction:true}, 
//         'RE-02': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0}, 
//         'RE-06': {'edge': [0, 3], 'amper': [], 'volt': [], 'resist': 330.0}, 
//         'VE-07': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 93333148.667, direction: false},
//         'RE-04': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 330.0}, 
//         'RE-05': {'edge': [2, 3], 'amper': [], 'volt': [], 'resist': 330.0}
//         }, 
//     'node_info': {
//         0: {
//             'comps': ['BB-00-A7', 'BB-00-F7', 'RE-02-PS', 'BB-00-UP', 'RE-06-PS', 'PW-11', 'BB-00-F4', 'RE-03-PS', 'PW-11-PS'], 
//             'equation': [[1, 0, 0], {"type" : "SINE", "freq" : 2, "amp" : 7,"offset" : 0}], 
//             'volt': []
//             }, 
//         1: {
//             'comps': ['RE-02-MS', 'BB-00-F12', 'RE-04-PS', 'RE-03-MS', 'VE-07-VI'], 
//             'equation': [[-0.00606060605960049, 0.009090919089898938, -0.0030303130302984484], 0], 
//             'volt': []
//             }, 
//         2: {
//             'comps': ['BB-00-F17', 'RE-05-PS', 'RE-04-MS', 'VE-07-CM'], 
//             'equation': [[0, -0.0030303130302984484, 0.006060616060144737], 0.0], 
//             'volt': []
//             }, 
//         3: {
//             'comps': ['BB-00-UM', 'BB-00-A22', 'BB-00-A12', 'RE-05-MS', 'RE-06-MS', 'GND', 'BB-00-F22', 'PW-11-MS'], 
//             'equation': "None", 
//             'volt': [0]}
//             }, 
//     'circuit_info': {'type': 'period', 'period time': 1000 , 'sampling count': 1000, 'time list': []}}
    
// const rectangle_case = {
//     'paths': [
//         ['RE-06', 'WL-09', 'WL-04', 'WL-10', 'PW-11', 'WL-06', 'WL-02', 'WL-03', 'WL-08'], 
//         ['WL-09', 'WL-04', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'WL-03', 'RE-05'], 
//         ['RE-02', 'WL-09', 'WL-04', 'WL-05', 'PW-11', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'RE-02', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'WL-02', 'WL-03', 'RE-05']
//         ], 
//     'result': {
//         'RE-03': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-02': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-06': {'edge': [0, 3], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'VE-07': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 93333148.667, direction: false}, 
//         'RE-04': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-05': {'edge': [2, 3], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}
//         }, 
//     'node_info': {
//         0: {
//             'comps': ['BB-00-A7', 'BB-00-F7', 'RE-02-PS', 'BB-00-UP', 'RE-06-PS', 'PW-11', 'BB-00-F4', 'RE-03-PS', 'PW-11-PS'], 
//             'equation': [[1, 0, 0], {"type" : "rec", "freq" : 2, "amp" : 5,"offset" : 0}], 
//             'volt': []
//             }, 
//         1: {
//             'comps': ['RE-02-MS', 'BB-00-F12', 'RE-04-PS', 'RE-03-MS', 'VE-07-VI'], 
//             'equation': [[-0.00606060605960049, 0.009090919089898938, -0.0030303130302984484], 0], 
//             'volt': []
//             }, 
//         2: {
//             'comps': ['BB-00-F17', 'RE-05-PS', 'RE-04-MS', 'VE-07-CM'], 
//             'equation': [[0, -0.0030303130302984484, 0.006060616060144737], 0.0], 
//             'volt': []
//             }, 
//         3: {
//             'comps': ['BB-00-UM', 'BB-00-A22', 'BB-00-A12', 'RE-05-MS', 'RE-06-MS', 'GND', 'BB-00-F22', 'PW-11-MS'], 
//             'equation': "None", 
//             'volt': [0]}
//             }, 
//     'circuit_info': {'type': 'period', 'period time': 1000 , 'sampling count': 1000, 'time list': []}}
    
// const triangle_case = {
//     'paths': [
//         ['RE-06', 'WL-09', 'WL-04', 'WL-10', 'PW-11', 'WL-06', 'WL-02', 'WL-03', 'WL-08'], 
//         ['WL-09', 'WL-04', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'WL-03', 'RE-05'], 
//         ['RE-02', 'WL-09', 'WL-04', 'WL-05', 'PW-11', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'RE-02', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'WL-02', 'WL-03', 'RE-05']
//         ], 
//     'result': {
//         'RE-03': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-02': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-06': {'edge': [0, 3], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'VE-07': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 93333148.667, direction: false}, 
//         'RE-04': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-05': {'edge': [2, 3], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}
//         }, 
//     'node_info': {
//         0: {
//             'comps': ['BB-00-A7', 'BB-00-F7', 'RE-02-PS', 'BB-00-UP', 'RE-06-PS', 'PW-11', 'BB-00-F4', 'RE-03-PS', 'PW-11-PS'], 
//             'equation': [[1, 0, 0], {"type" : "tri", "freq" : 3, "amp" : 5,"offset" : 0}], 
//             'volt': []
//             }, 
//         1: {
//             'comps': ['RE-02-MS', 'BB-00-F12', 'RE-04-PS', 'RE-03-MS', 'VE-07-VI'], 
//             'equation': [[-0.00606060605960049, 0.009090919089898938, -0.0030303130302984484], 0], 
//             'volt': []
//             }, 
//         2: {
//             'comps': ['BB-00-F17', 'RE-05-PS', 'RE-04-MS', 'VE-07-CM'], 
//             'equation': [[0, -0.0030303130302984484, 0.006060616060144737], 0.0], 
//             'volt': []
//             }, 
//         3: {
//             'comps': ['BB-00-UM', 'BB-00-A22', 'BB-00-A12', 'RE-05-MS', 'RE-06-MS', 'GND', 'BB-00-F22', 'PW-11-MS'], 
//             'equation': "None", 
//             'volt': [0]}
//             }, 
//     'circuit_info': {'type': 'period', 'period time': 1000 , 'sampling count': 1000, 'time list': []}}

// const staticNone = {
//     'paths': [
//         ['RE-06', 'WL-09', 'WL-04', 'WL-10', 'PW-11', 'WL-06', 'WL-02', 'WL-03', 'WL-08'], 
//         ['WL-09', 'WL-04', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'WL-03', 'RE-05'], 
//         ['RE-02', 'WL-09', 'WL-04', 'WL-05', 'PW-11', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'RE-02', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'WL-02', 'WL-03', 'RE-05']
//         ], 
//     'result': {
//         'RE-03': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-02': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-06': {'edge': [0, 3], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'VE-07': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 93333148.667, direction: false}, 
//         'RE-04': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-05': {'edge': [2, 3], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}
//         }, 
//     'node_info': {
//         0: {
//             'comps': ['BB-00-A7', 'BB-00-F7', 'RE-02-PS', 'BB-00-UP', 'RE-06-PS', 'PW-11', 'BB-00-F4', 'RE-03-PS', 'PW-11-PS'], 
//             'equation': 'None', 
//             'volt': [5]
//             }, 
//         1: {
//             'comps': ['BB-00-UM', 'BB-00-A22', 'BB-00-A12', 'RE-05-MS', 'RE-06-MS', 'GND', 'BB-00-F22', 'PW-11-MS'], 
//             'equation': "None", 
//             'volt': [0]}
//             }, 
//     'circuit_info': {'type': 'static', 'period time':1000 , 'sampling count': 1000, 'time list': []}
// }

// const static = {
//     'paths': [
//         ['RE-06', 'WL-09', 'WL-04', 'WL-10', 'PW-11', 'WL-06', 'WL-02', 'WL-03', 'WL-08'], 
//         ['WL-09', 'WL-04', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'RE-03', 'WL-02', 'WL-03', 'RE-05'], 
//         ['RE-02', 'WL-09', 'WL-04', 'WL-05', 'PW-11', 'WL-02', 'RE-04', 'WL-03', 'RE-05'], 
//         ['WL-11', 'RE-02', 'VE-07', 'WL-09', 'WL-04', 'WL-12', 'WL-05', 'PW-11', 'WL-02', 'WL-03', 'RE-05']
//         ], 
//     'result': {
//         'RE-03': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-02': {'edge': [0, 1], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-06': {'edge': [0, 3], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'VE-07': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 93333148.667, direction: false}, 
//         'RE-04': {'edge': [1, 2], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}, 
//         'RE-05': {'edge': [2, 3], 'amper': [], 'volt': [], 'resist': 330.0, direction: true}
//         }, 
//     'node_info': {
//         0: {
//             'comps': ['BB-00-A7', 'BB-00-F7', 'RE-02-PS', 'BB-00-UP', 'RE-06-PS', 'PW-11', 'BB-00-F4', 'RE-03-PS', 'PW-11-PS'], 
//             'equation': [[1,0,0],5], 
//             'volt': []
//             },
//             1: {
//                 'comps': ['RE-00-MS', 'RE-02-PS', 'RE-01-PS'],
//                 'equation': [[0.8749999757339176, -0.24999999998495104, 2], 0],
//                 'volt': []
//             },
//             2: {
//                 'comps': ['VE-00-VI', 'RE-04-PS', 'RE-03-PS', 'RE-01-MS'],
//                 'equation': [[-0.24999999998495104, 1.4499999152821443, 0.5], 0],
//                 'volt': []
//             },
//             3: {
//             'comps': ['BB-00-UM', 'BB-00-A22', 'BB-00-A12', 'RE-05-MS', 'RE-06-MS', 'GND', 'BB-00-F22', 'PW-11-MS'], 
//             'equation': "None", 
//             'volt': [0]
//             }
//             }, 
//     'circuit_info': {'type': 'static', 'period time':1000 , 'sampling count': 1000, 'time list': []}
// }

// const newData = {
//     '0':{ 'result': {'RE-05': {'edge': [0, 1], 'resist': 3.0, 'volt': [], 'amper': []}, 'RE-08': {'edge': [2, 3], 'resist': 2.0, 
//     'volt': [], 'amper': []}, 'RE-07': {'edge': [3, 4], 'resist': 5.0, 'volt': [], 'amper': []}, 'RE-04': {'edge': [4, 5], 'resist': 10.0, 'volt': [], 'amper': []}}, 'node_info': {0: {'comps': ['PW-21', 'BB-00-LP', 'RE-05-PS', 'PW-21-PS', 'BB-00-F21'], 'equation': [[1, 0, 0, 0, 0], 6], 'volt': [6]}, 1: {'comps': ['BB-00-F26', 'BB-00-UM', 'PW-11-MS', 'RE-05-MS'], 'equation': [[0, -1, 1, 0, 0], 6], 'volt': [6]}, 2: {'comps': ['BB-00-UP', 'RE-08-PS', 'BB-00-F3', 'PW-11-PS'], 'equation': [[-0.333333, 0.333333, 0.5, -0.5, 0], 0], 'volt': []}, 3: {'comps': ['RE-08-MS', 'RE-07-PS', 'BB-00-F8'], 'equation': [[0, 0, -0.5, 0.7, -0.2], 0], 'volt': []}, 4: {'comps': ['BB-00-F13', 'RE-07-MS', 'RE-04-PS'], 'equation': [[0, 0, 0, -0.2, 0.30000000000000004], 0], 'volt': []}, 5: {'comps': ['BB-00-LM', 'PW-21-MS', 'BB-00-F18', 'RE-04-MS', 'GND'], 'equation': 'None', 'volt': [0]}}, 'circuit_info': {'type': 'static'}},
    
//     '1': {'result': {'RE-03': {'edge': [0, 1], 'resist': 330.0, 'volt': [], 'amper': []}, 'RE-02': {'edge': [1, 2], 'resist': 330.0, 'volt': [], 'amper': []}}, 'node_info': {0: {'comps': ['FG-10-PS', 'FG-10', 'BB-01-F21', 'RE-03-MS'], 'equation': [[1, 0], {'freq': 10, 'amp': 2, 'offset': 1, 'type': 'sine'}], 'volt': [{'freq': 10, 'amp': 2, 'offset': 1, 'type': 'sine'}]}, 1: {'comps': ['RE-02-MS', 'RE-03-PS', 'BB-01-F16'], 'equation': [[-0.00303, 0.00606], 0], 'volt': []}, 2: {'comps': ['RE-02-PS', 'BB-01-F11', 'FG-10-MS', 'GND'], 'equation': 'None', 'volt': [0]}}, 'circuit_info': {'type': 'period', 'period time': 100.0, 'sampling count': 100, 'time interval': '0.001000', 'time list': []}},
    
//     'paths' : [['WL-03', 'RE-02', 'PW-21', 'PW-11', 'RE-05', 'WL-05', 'WL-11', 'WL-09', 'WL-02', 'WL-06', 'WL-08', 'WL-01', 'RE-03', 'RE-04'], ['RE-03', 'FG-10', 'RE-02', 'WL-02', 'WL-03']]    
// }

function getEquations(info, time=null)
{
    const equations = {
        matrix: [],
        constV: []
    }

    if (time == null)
    {
        for (const [k,v] of Object.entries(info))
        {
            const nodeEquation = v.equation;
            if (nodeEquation != 'None' && nodeEquation != null)     // 빈 equation 데이터 형태 확인하고 수정하기
            {
                equations.matrix.push(nodeEquation[0]);
                equations.constV.push(nodeEquation[1]);
            }
        }
    }

    else
    {
        const PI = Math.PI;

        for (const [k,v] of Object.entries(info))
        {
            const nodeEquation = v.equation;
            if (nodeEquation != 'None' && nodeEquation != null)     // 빈 equation 데이터 형태 확인하고 수정하기
            {
                equations.matrix.push(nodeEquation[0]);
                if (typeof nodeEquation[1] == 'object')
                {
                    const type = nodeEquation[1].type;
                    let value = nodeEquation[1].offset;
                    const freqMulTime = (2*PI*nodeEquation[1].freq) * time*0.001;

                    if (type == 'sine')
                    {
                        value += nodeEquation[1].amp * Math.sin(freqMulTime);
                    }
                    else if (type == 'tri')
                    {
                        let tmpSum = 0;
                        for (let i=1;i<501;i++)
                        {
                            tmpSum += ((2/(2*i-1))*(1/PI))**2 *Math.cos((2*i-1)*freqMulTime);
                        }
                        value += 2 * nodeEquation[1].amp * tmpSum;
                    }
                    else if (type == 'square')
                    {
                        let tmpSum = 0;
                        for (let i=1;i<501;i++)
                        {
                            tmpSum += (2/(2*i-1))*(1/PI)*Math.sin((2*i-1)*freqMulTime);
                        }
                        value += 2 * nodeEquation[1].amp * tmpSum;
                    }

                    equations.constV.push(value);
                }
                else
                {
                    equations.constV.push(nodeEquation[1]);
                }
            }
        }
    }

    return equations;
}

function solveEquation(info, time=null)
{
    let equations;

    if (time == null)
    {
        equations = getEquations(info);
    }
    else
    {
        equations = getEquations(info, time);
    }

    const matrix = equations.matrix;
    const constV = equations.constV;

    if (matrix.length == 0)
    {
        return [];
    }

    const result = math.lusolve(matrix, constV);

    return result;   // volt list
}

function inputNodesVolt(node_info, voltArr)
{
    const len = voltArr.length;
    
    for (let i=0; i<len; i++)
    {
        node_info[i].volt.push(voltArr[i]);
    }

}

function inputEquipAttr(node_info, result, dataSet)
{
    for (let [equip, attrs] of Object.entries(result))
    {
        const fromEdge = attrs.edge[0];
        const toEdge = attrs.edge[1];
        const fromidx = node_info[fromEdge].volt.length;
        const toidx = node_info[toEdge].volt.length;

        const equipVolt = node_info[fromEdge].volt[fromidx-1] - node_info[toEdge].volt[toidx-1];
        const equipAmper = equipVolt/attrs.resist;

        if (attrs.direction == undefined || attrs.direction == true){
            attrs.volt.push(equipVolt);
            attrs.amper.push(equipAmper);
        }
        else {
            attrs.volt.push(-equipVolt);
            attrs.amper.push(-equipAmper);
        }
        dataSet.values[equip] = attrs;
    }
}

function processData(data, dataSet)
{
    const circuit_info = data.circuit_info;
    const nodeInfo = data.node_info;
    const result = data.result;

    if (!circuit_info || !nodeInfo || !result) return

    if (circuit_info['type'] == 'static')
    {
        const voltArr = solveEquation(nodeInfo);

        if (voltArr.length == 0)
        {
            return;
        }

        inputNodesVolt(nodeInfo, voltArr);
        inputEquipAttr(nodeInfo, result, dataSet);
    }

    else if (circuit_info['type'] == 'period')
    {
        const periodTime = circuit_info['period time'];
        const samplingCnt = circuit_info['sampling count'];
        const timeList = circuit_info['time list'];
        const interval = periodTime/samplingCnt;
        
        let time = 0;
        for (let i=0; i<samplingCnt+1; i++)
        {
            time = interval*i;
            timeList.push(time);

            const voltArr = solveEquation(nodeInfo, time);
            if (voltArr.length == 0)
            {
                return;
            }

            inputNodesVolt(nodeInfo, voltArr);
            inputEquipAttr(nodeInfo, result, dataSet);
        }
    }
}

// main function
function processDataSet(dataSet)
{
    // console.log(Object.entries(dataSet))
    const dataArr = Object.entries(dataSet);
    for (let i=0; i<dataArr.length-1; i++)
    {
        if (dataSet.values == undefined)
        {
            dataSet.values = {}
        }
        processData(dataArr[i][1], dataSet);
    }
}

export default { processDataSet };

// <Test>
// processDataSet(newData);
// processData(one_fg_ex_res_code);
// processData(rectangle_case);
// processData(triangle_case);
// processData(staticNone);
// processData(static);

// console.log(newData);
// console.log(one_fg_ex_res_code);
// console.log(rectangle_case);
// console.log(triangle_case);
// console.log(staticNone);
// console.log(static);

// var board = JXG.JSXGraph.initBoard('box', {boundingbox: [0, 15, 1000, -15], axis:true});

// const timeList = one_fg_ex_res_code.circuit_info['time list'];
// const volt = one_fg_ex_res_code.node_info[0].volt;
// const voltR = rectangle_case.node_info[0].volt;
// const voltT = triangle_case.node_info[0].volt;

// for (let i=0;i<1001;i++)
// {
//     const time = timeList[i];
//     const v = volt[i][0];
//     const vR = voltR[i][0];
//     const vT = voltT[i][0];

//     var point = board.create('point', [time,v], {strokeColor : 'green', size:0.1});
//     var pointR = board.create('point', [time,vR], {strokeColor : 'blue', size:0.1});
//     var pointT = board.create('point', [time, vT], {strokeColor : 'purple', size:0.1});
// }


// console.log(one_fg_ex_res_code);
// console.log(rectangle_case);
// console.log(triangle_case);
// console.log(staticNone);
// console.log(static);

// var board = JXG.JSXGraph.initBoard('box', {boundingbox: [0, 15, 1000, -15], axis:true});

// const timeList = one_fg_ex_res_code.circuit_info['time list'];
// const volt = one_fg_ex_res_code.node_info[0].volt;
// const voltR = rectangle_case.node_info[0].volt;
// const voltT = triangle_case.node_info[0].volt;

// for (let i=0;i<1001;i++)
// {
//     const time = timeList[i];
//     const v = volt[i][0];
//     const vR = voltR[i][0];
//     const vT = voltT[i][0];

//     var point = board.create('point', [time,v], {strokeColor : 'green', size:0.1});
//     var pointR = board.create('point', [time,vR], {strokeColor : 'blue', size:0.1});
//     var pointT = board.create('point', [time, vT], {strokeColor : 'purple', size:0.1});
// }
